<script setup lang="ts">
import DecorIcon from "#ui/primitives/decorIcon/DecorIcon.vue";
import type { CartIconControl } from "../cartControls";

defineProps<{ control: CartIconControl }>();
</script>

<template>
	<DecorIcon :icon="control.icon" :fallback="control.fallback" />
</template>
